import { useCallback, useEffect, useState } from 'react';
import { useAtomValue } from 'jotai';
import { loginStateAtom, userDataAtom } from '../../AtomStore';
import { normalizeUserType } from '../login/userTypeUtils';
import { pastorApi } from './pastorApi';
import type { PastorProfile } from './pastorApi';

// 로그인 회원의 유형 + 담임목회 희망 이력서
export function usePastorMe() {
  const isLogin = useAtomValue(loginStateAtom);
  const userData = useAtomValue(userDataAtom);
  const [me, setMe] = useState<{ userType: string; pastorProfile: PastorProfile | null } | null>(null);
  const [loading, setLoading] = useState(isLogin);

  const reload = useCallback(async () => {
    if (!isLogin) {
      setMe(null);
      setLoading(false);
      return;
    }
    setLoading(true);
    try {
      setMe(await pastorApi.me());
    } catch {
      setMe(null);
    } finally {
      setLoading(false);
    }
  }, [isLogin]);

  useEffect(() => {
    reload();
  }, [reload]);

  const userType = normalizeUserType(me?.userType || userData.userType);
  return { isLogin, loading, me, reload, userType, isChurch: userType === 'CHURCH' };
}
